<template>
  <div>
    <Frontendlayout>
      <section class="hero_in tours">
        <div class="wrapper">
          <div class="container">
            <h1 class="fadeInUp"><span></span>Rewards</h1>
          </div>
        </div>
      </section>
      <!--/hero_in-->

      <div class="container-fluid">
        <div class="row">
          <Sidebar />
          <!-- /aside -->

          <div class="col-lg-10">
            <div class="isotope-wrapper">
              <div class="box_general padding_bottom">
                <div class="header_box version_2">
                  <center><h2>Coming Soon</h2></center>
                </div>
              </div>
              <!-- /row -->
            </div>
            <!-- /isotope-wrapper -->
          </div>
          <!-- /col -->
        </div>
      </div>

      <!-- /container -->
      <!-- /bg_color_1 -->
    </Frontendlayout>
  </div>
</template>

<script>
import Frontendlayout from "../layouts/Frontendlayout.vue";
import Sidebar from "../layouts/Sidebar.vue";
import moment from "moment";

export default {
  data() {
    return {
      roleId: localStorage.getItem("role_id"),
      token: "Bearer " + localStorage.getItem("token"),
      msg: null,
      classAlert: null,
      profileDetails: [],
      profile_img: null,
      image: "",
    };
  },
  components: {
    Frontendlayout,
    Sidebar,
  },
  beforeMount() {
    this.checkToken();
  },

  methods: {
    checkToken() {
      //alert(this.token);
      if (this.token == "Bearer " + null) {
        this.$router.push("/signin");
      }
    },

    frontEndDateFormat(date) {
      //alert(moment(date, "YYYY-MM-DD").format("DD-MM-YYYY"));
      return moment(date, "YYYY-MM-DD").format("DD-MM-YYYY");
    },
    backEndDateFormat: function (date) {
      return moment(date, "DD-MM-YYYY").format("YYYY-MM-DD");
    },
  },
};
</script>
<style  scoped>
@import "../../public/frontend/vendor/dropzone.css";

.show_img,
.header_box img {
  width: 100px;
  height: 100px;
}
</style>